import { LangDefinition } from '@jsverse/transloco';

export interface FullLangDefinition extends LangDefinition {
  fullName: string;
}

export const AVAILABLE_LANGS: FullLangDefinition[] = [
  {
    id: 'pl',
    label: 'Polski',
    fullName: 'Polish',
  },
  {
    id: 'en',
    label: 'English',
    fullName: 'English',
  },
];
